// Shows a fade on the right edge of the child category row while there is more to scroll
// sideways, so it is clear that the row continues outside the screen. The fade itself is
// ::after on .category-page__navigation.

const scrollableClass = 'category-page__navigation--scrollable';

// The row lives inside #search-result and is replaced on every AJAX filter swap, so the
// current elements are kept here and the window listener is only bound once.
let currentContainer = null;
let currentRow = null;
let resizeBound = false;

function update() {
    if (!currentContainer || !currentRow) {
        return;
    }

    const remaining =
        currentRow.scrollWidth - currentRow.clientWidth - currentRow.scrollLeft;

    if (remaining > 1) {
        currentContainer.classList.add(scrollableClass);
    } else {
        currentContainer.classList.remove(scrollableClass);
    }
}

export function CategoryNavigationScrollHint() {
    const container = document.querySelector('.category-page__navigation');
    const row =
        container &&
        container.querySelector('.category-page__navigation-wrapper');

    if (!row) {
        currentContainer = null;
        currentRow = null;
        return;
    }

    currentContainer = container;
    currentRow = row;

    row.addEventListener('scroll', update);

    if (!resizeBound) {
        window.addEventListener('resize', update);
        resizeBound = true;
    }

    update();
}
